import * as React from 'react';
import { cn } from '../cn';

const palette = ['bg-accent', 'bg-green', 'bg-orange', 'bg-purple', 'bg-teal', 'bg-indigo', 'bg-red'];

export function initialsOf(name?: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1]![0] : '')).toUpperCase() || '?';
}

export interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  name?: string | null;
  src?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: string;
}
export function Avatar({ name, src, size = 'md', color, className, ...props }: AvatarProps) {
  const dims = { xs: 'size-5 text-[9px]', sm: 'size-7 text-[11px]', md: 'size-9 text-[13px]', lg: 'size-12 text-[16px]' }[size];
  let hash = 0;
  for (const ch of name ?? '') hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  const bg = color ? undefined : palette[hash % palette.length];
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white select-none overflow-hidden', dims, bg, className)} style={color ? { background: color } : undefined} aria-label={name ?? undefined} {...props}>
      {src ? <img src={src} alt={name ?? ''} className="size-full object-cover" /> : initialsOf(name)}
    </span>
  );
}
